/**
 * OW Scratchcard — Canvas scratch, weighted prizes, confetti, copy code, coupon redirect
 */
(function(){
'use strict';

var REVEAL_THRESHOLD = 0.45;
var revealed = false;
var canvas, ctx, W, H, scratching = false;

function init() {
  canvas = document.getElementById('sc-canvas');
  if (!canvas) return;
  ctx = canvas.getContext('2d');
  setupCanvas();
  pickPrize();
  bindEvents();
  window.addEventListener('resize', function(){ if (!revealed) setupCanvas(); });
}

function setupCanvas() {
  var rect = canvas.parentElement.getBoundingClientRect();
  W = Math.round(rect.width);
  H = Math.round(rect.height);
  var dpr = Math.min(window.devicePixelRatio || 1, 2);
  canvas.width = W * dpr; canvas.height = H * dpr;
  canvas.style.width = W + 'px'; canvas.style.height = H + 'px';
  ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
  drawScratchLayer();
}

function drawScratchLayer() {
  ctx.globalCompositeOperation = 'source-over';
  var grad = ctx.createLinearGradient(0, 0, W, H);
  grad.addColorStop(0, '#c8dbe8');
  grad.addColorStop(0.5, '#b8ccd8');
  grad.addColorStop(1, '#a8bcc8');
  ctx.fillStyle = grad;
  roundRect(ctx, 0, 0, W, H, 20);
  ctx.fill();

  ctx.fillStyle = 'rgba(255,255,255,0.06)';
  for (var i = 0; i < 200; i++) {
    ctx.fillRect(Math.random()*W, Math.random()*H, Math.random()*3+1, Math.random()*3+1);
  }

  ctx.fillStyle = 'rgba(255,255,255,0.4)';
  ctx.font = '600 ' + Math.round(W * 0.045) + 'px "Plus Jakarta Sans",system-ui,sans-serif';
  ctx.textAlign = 'center';
  ctx.fillText('✦  Hier freirubbeln  ✦', W / 2, H / 2 + 5);
}

function roundRect(c, x, y, w, h, r) {
  c.beginPath();
  c.moveTo(x+r,y); c.lineTo(x+w-r,y); c.quadraticCurveTo(x+w,y,x+w,y+r);
  c.lineTo(x+w,y+h-r); c.quadraticCurveTo(x+w,y+h,x+w-r,y+h);
  c.lineTo(x+r,y+h); c.quadraticCurveTo(x,y+h,x,y+h-r);
  c.lineTo(x,y+r); c.quadraticCurveTo(x,y,x+r,y);
  c.closePath();
}

function pickPrize() {
  var prizes = window.__sc_prizes || [];
  if (!prizes.length) return;
  var total = 0;
  prizes.forEach(function(p){ total += (p.weight || 1); });
  var r = Math.random() * total, acc = 0, chosen = prizes[0];
  for (var i = 0; i < prizes.length; i++) {
    acc += (prizes[i].weight || 1);
    if (r <= acc) { chosen = prizes[i]; break; }
  }
  window.__sc_chosen = chosen;

  var el = document.getElementById('sc-prize-value');
  var desc = document.getElementById('sc-prize-desc');
  var emoji = document.getElementById('sc-prize-emoji');
  if (el) el.textContent = chosen.label || '';
  if (desc) desc.textContent = chosen.desc || '';
  if (emoji) emoji.textContent = chosen.emoji || '🎁';
}

function bindEvents() {
  canvas.addEventListener('mousedown', startScratch);
  canvas.addEventListener('mousemove', doScratch);
  canvas.addEventListener('mouseup', stopScratch);
  canvas.addEventListener('mouseleave', stopScratch);
  canvas.addEventListener('touchstart', startScratch, { passive: false });
  canvas.addEventListener('touchmove', doScratch, { passive: false });
  canvas.addEventListener('touchend', stopScratch);
}

function getPos(e) {
  var rect = canvas.getBoundingClientRect();
  var t = e.touches ? e.touches[0] : e;
  return { x: t.clientX - rect.left, y: t.clientY - rect.top };
}

function startScratch(e) {
  if (revealed) return;
  e.preventDefault();
  scratching = true;
  var hint = document.querySelector('.sc-card__hint');
  if (hint) hint.classList.add('is-hidden');
  scratch(getPos(e));
}

function doScratch(e) {
  if (!scratching || revealed) return;
  e.preventDefault();
  scratch(getPos(e));
}

function stopScratch() { scratching = false; }

function scratch(pos) {
  ctx.globalCompositeOperation = 'destination-out';
  ctx.beginPath();
  ctx.arc(pos.x, pos.y, 22, 0, Math.PI * 2);
  ctx.fill();

  ctx.beginPath();
  ctx.lineWidth = 44;
  ctx.lineCap = 'round';
  ctx.moveTo(pos.x, pos.y);
  ctx.lineTo(pos.x + 0.1, pos.y + 0.1);
  ctx.stroke();

  checkReveal();
}

function checkReveal() {
  if (revealed) return;
  var data = ctx.getImageData(0, 0, canvas.width, canvas.height).data;
  var total = data.length / 4, cleared = 0;
  for (var i = 3; i < data.length; i += 16) {
    if (data[i] === 0) cleared++;
  }
  var frac = cleared / (total / 4);
  if (frac >= REVEAL_THRESHOLD) doReveal();
}

function doReveal() {
  revealed = true;
  ctx.globalCompositeOperation = 'destination-out';
  ctx.fillStyle = '#000';
  ctx.fillRect(0, 0, canvas.width, canvas.height);
  canvas.style.pointerEvents = 'none';

  setTimeout(fireConfetti, 200);
  setTimeout(showRevealUI, 600);
}

function showRevealUI() {
  var chosen = window.__sc_chosen || {};
  var revealEl = document.getElementById('sc-reveal');
  var recsEl = document.getElementById('sc-recs');
  var titleEl = document.getElementById('sc-reveal-title');
  var descEl = document.getElementById('sc-reveal-desc');
  var codeEl = document.getElementById('sc-reveal-code');
  var linkEl = document.getElementById('sc-reveal-link');

  if (titleEl) titleEl.textContent = chosen.label || '';
  if (descEl) descEl.textContent = chosen.desc || '';
  if (codeEl) codeEl.textContent = chosen.code || '';
  if (linkEl) {
    linkEl.href = chosen.code ? '/discount/' + encodeURIComponent(chosen.code) + '?redirect=/' : '/';
  }
  if (revealEl) revealEl.classList.add('is-active');
  if (recsEl) recsEl.classList.add('is-active');
}

function fireConfetti() {
  var c = document.getElementById('sc-confetti');
  if (!c) return;
  var cx = c.getContext('2d');
  var vw = window.innerWidth, vh = window.innerHeight;
  c.width = vw * 2; c.height = vh * 2;
  c.style.width = vw + 'px'; c.style.height = vh + 'px';
  cx.setTransform(2, 0, 0, 2, 0, 0);
  var parts = [], colors = ['#008cff','#34c77b','#ffcd38','#ff6b6b','#a78bfa','#00d4ff','#fff'];
  for (var i = 0; i < 120; i++) {
    parts.push({
      x: vw/2 + (Math.random()-.5)*150, y: vh*0.35,
      vx: (Math.random()-.5)*11, vy: -(Math.random()*9+5),
      w: Math.random()*8+3, h: Math.random()*5+2,
      c: colors[Math.floor(Math.random()*colors.length)],
      r: Math.random()*360, rv: (Math.random()-.5)*14, life: 1
    });
  }
  (function tick(){
    cx.clearRect(0,0,vw,vh); var alive=false;
    parts.forEach(function(p){
      p.vy+=0.28; p.x+=p.vx; p.y+=p.vy; p.r+=p.rv; p.life-=0.008;
      if(p.life<=0)return; alive=true;
      cx.save(); cx.translate(p.x,p.y); cx.rotate(p.r*Math.PI/180);
      cx.globalAlpha=Math.max(0,p.life); cx.fillStyle=p.c;
      cx.fillRect(-p.w/2,-p.h/2,p.w,p.h); cx.restore();
    });
    if(alive)requestAnimationFrame(tick);else cx.clearRect(0,0,vw,vh);
  })();
}

window.scCopyCode = function(btn) {
  var code = document.getElementById('sc-reveal-code');
  if (!code) return;
  navigator.clipboard.writeText(code.textContent).then(function(){
    btn.textContent = 'Kopiert ✓';
    btn.classList.add('is-copied');
    setTimeout(function(){ btn.textContent = 'Code kopieren'; btn.classList.remove('is-copied'); }, 2000);
  });
};

document.addEventListener('DOMContentLoaded', init);
})();
